import { useFrame } from '@react-three/fiber';
import { useMemo } from 'react';
import { createGetOrbitINC } from 'src/threejs/components/OrbitManager/store/getters';
import { MarkerProps } from 'src/types';
import { Vector3 } from 'three';
import Marker from '../../../Marker';
import { use3DOrbitContext } from '../../context';
import IncMarkerHandle from './IncMarkerHandle';

/** The inclination marker. */
const IncMarker = ({ handle, setHandle, marker, setMarker }: MarkerProps) => {
  const { id, size } = use3DOrbitContext();
  const getOrbitINC = useMemo(() => createGetOrbitINC(id), [id]);

  const scale = useMemo(() => new Vector3().setScalar(size / 50), [size]);

  useFrame(() => {
    const { x, y, z } = getOrbitINC();

    if (marker) {
      marker.position.set(x, y, z);
    }
  });

  return (
    <>
      <Marker
        marker={marker}
        setMarker={setMarker}
        markerName="INC Marker"
        scale={scale}
      >
        <sphereGeometry />
        <meshBasicMaterial
          color={0x00ffff}
          transparent={true}
          opacity={0.75}
          depthWrite={false}
        />
      </Marker>
      <IncMarkerHandle
        handle={handle}
        setHandle={setHandle}
      />
    </>
  );
};

export default IncMarker;
